import { render, staticRenderFns } from "./SimilarGenes.vue?vue&type=template&id=22bf7eb7&"
import script from "./SimilarGenes.vue?vue&type=script&lang=js&"
export * from "./SimilarGenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports